//export const APIURL = 'http://localhost:3001/';
export const APIURL = 'http://rovanieminature.plab.fi/';
//export const APIURL = 'http://plab.lapinamk.fi:8001/';

export const AUTHORIZATION = 'authorization';
export const LANG = 'lang';

export const METSAINEN = 'metsainen';
export const LUONTO = 'luontorovaniemi';
export const ENV = LUONTO;
export const SOFT_DELETE = true;

export const LOCALES = {
  fi: {
    users: {
      'Are you sure you want to delete the selected user?':
        'Oletko varma, että haluat poistaa käyttäjän?',
      'Change Password': 'Vaihda salasana',
      Users: 'Käyttäjät',
      Login: 'Kirjaudu',
      Logout: 'Ulos',
      Username: 'Käyttäjänimi',
      Password: 'Salasana',
      username: 'käyttäjänimi',
      password: 'salasana',
      Role: 'Rooli',
      guest: 'vieras',
      moderator: 'moderaattori',
      admin: 'pääkäyttäjä',
      'User updated successfully': 'Käyttäjä päivitetty',
      'Confirm password': 'Vahvista salasana',
      Confirmation: 'Vahvistus',
      'User deleted successfully': 'Käyttäjä poistettu',
      'Error deleting user': 'Käyttäjän poisto epäonnistui',
      'User created successfully': 'Uusi käyttäjä luotu',
      'Add user': 'Lisää käyttäjä',
      Account: 'Oma tili'
    },
    home: {
      Home: 'Etusivu'
    },
    userValidation: {
      '{0} is required': '{0} on pakollinen',
      'Invalid {0} or {1}': 'Virheellinen {0} tai {1}',
      'Username must be unique': 'Käyttäjänimen on oltava yksilöllinen',
      'Password and confirmation have to match':
        'Salasanan ja vahvistuksen täytyy olla samat'
    },

    error: {
      'User not found': 'Käyttäjää ei löydy',
      'Edit your own profile via account': 'Muokkaa omia tietoja tilin kautta',
      Unauthorized: 'Sinulla ei ole oikeutta tähän toimintoon'
    },

    dt: {
      'rows per page': 'riviä sivulla',
      'rows {0} - {1}': 'rivit {0} - {1}',
      All: 'Kaikki'
    },

    checkpoints: {
      'Edit Checkpoint': 'Muokkaa rastia',
      'Add Task': 'Lisää tehtävä',
      'Enable Dragging': 'Vaihda järjestystä raahaamalla tehtäviä',
      'Disable Dragging': 'Ota järjestyksen vaihto raahaamalla pois päältä',

      'No tasks': 'Ei tehtäviä'
    },

    seasons: {
      Winter: 'Talvi',
      Spring: 'Kevät',
      Summer: 'Kesä',
      Autumn: 'Syksy'
    },

    routeValidator: {
      'Route name must be unique':
        'Reitin nimi ei saa olla tyhjä ja sen pitää olla yksilöllinen'
    },

    tasks: {
      Tasks: 'Tehtävä(ä)',
      Answer: 'Vastaus',
      Text: 'Tekstitehtävä',
      'Single Image': 'Yksittäiskuvatehtävä',
      Image: 'Kuvatehtävä',
      Audio: 'Äänitehtävä',
      'Full Screen Video': 'Koko ruudun videotehtävä',
      'Season Video': 'Kausivideotehtävä',
      Camera: 'Kameratehtävä',
      CameraSlider: 'Kamerakuvakollaasi',
      YoutubeVideo: 'Youtube Video',
      Feedback: 'Palautetehtävä',
      'Info slides': 'Tekstikollaasitehtävä',
      'Task type': 'Tehtävätyyppi',
      Content: 'Tektisisältö',
      'Youtube Video Link': 'Youtubevideolinkki',
      'Are you sure you want to delete this task?':
        'Haluatko varmasti poistaa tämän tehtävän?',
      'Are you sure you want to delete the slide':
        'Haluatko varmasti poistaa ohjetekstin',
      'No tasks': 'Ei tehtäviä',
      'No tasktypes': 'Ei yhtään tehtävätyyppiä'
    },

    routes: {
      'Are you sure, you want to delete this checkpoint':
        'Haluatko varmasti poistaa tämän rastin',
      'Copy Accessible': 'Tee esteetön kopio',
      'Start and finish checkpoints cannot be deleted':
        'Aloitus -ja lopetusrastia ei voi poistaa',
      'More than one route have the same focus point, please select one':
        'Useammalla reitillä on sama keskipiste, valitse yksi',
      Upload: 'Lataa',
      Route: 'Reitti',
      'Youtube Link': 'Youtube-linkki',
      'Upload Image': 'Lataa kuva',
      'Add Youtube Video': 'Lisää Youtube-video',
      'Edit Route Group': 'Muokkaa Reittiryhmää',
      Routes: 'Reitit',
      'New Route': 'Uusi Reitti',
      'Route name': 'Reitin nimi',
      RouteGroup: 'Reittiryhmä',
      'Edit Route': 'Muokkaa Reittiä',
      'Edit Route - {0}': 'Muokkaa reittiä -  {0}',
      'Route Group': 'Reittiryhmä',
      'Route Length ({0})': 'Reitin pituus ({0})',
      'Calculate Length Automatically': 'Laske reitin pituus automaattisesti',
      Checkpoints: 'Rastit',
      Checkpoint: 'Rasti',
      'Geofence radius': 'Rastin ympärysmitta',
      'Add checkpoint': 'Lisää rasti',
      Published: 'Julkaistu',
      Accessible: 'Esteetön',
      'Keep marker attached to route node':
        'Pidä reittimerkki kiinnitettynä reittiin',
      'Draw line automatically between two points':
        'Piirrä reittiviiva automaattisesti kahden reittimerkin väliin',
      'Are you sure, you want to delete this route':
        'Haluatko varmasti poistaa reitin?'
    },

    'Rovaniemi Nature - Control Panel': 'Luonto Rovaniemi - Hallintapaneeli',
    'Page Not Found': 'Sivua ei löydy',
    'Nothing to show': 'Ei näytettävää',
    Delete: 'Poista',
    Edit: 'Muokkaa',
    Search: 'Hae',
    Save: 'Tallenna',
    Close: 'Sulje',
    Cancel: 'Peruuta',
    Yes: 'Kyllä',
    No: 'Ei',
    Feedback: 'Palaute',
    Hide: 'Piilota',
    'Only hidden': 'Vain piilotetut',
    "There's no checkpoints": 'Reitillä ei ole rasteja',
    draw: {
      'Draw a marker': 'Piirrä kohdepiste',
      'Click map to place marker':
        'Klikkaa karttaa hiirellä asettaaksesi kohdepiste kartalle',
      'Draw a polyline': 'Piirrä reittiviiva',
      'Click to start drawing line':
        'Klikkaa karttaa aloittaaksesi reitinpiirto',
      'Click last point to finish line':
        'Klikkaa viimeistä pistettä lopettaaksesi piirtäminen',
      'Click to continue drawing line': 'Klikkaa jatkaaksesi reittiviivaa'
    },

    drawEdit: {
      'Edit layers': 'Muokkaa tasoja',
      'No layers to edit': 'Ei muokattavia tasoja',
      'Delete layers': 'Poista tasoja',
      'No layers to delete': 'Ei poistettavia tasoja',
      'Drag handles or markers to edit features':
        'Vedä reittikahvoja tai kohdepisteitä muokataksesi',
      'Click cancel to undo changes':
        'Klikkaa peruuta peruuttaaksesi muutokset',
      'Click on a feature to remove':
        'Klikkaa kohdepistettä, tai reittiviivaa poistaaksesi ne kartalta'
    },

    leaflet: {
      'Zoom in': 'Lähennä',
      'Zoom out': 'Loitonna'
    },

    'You can drag and drop one image (png) file':
      'Voit ladata yhden kuvatiedoston (png) tähän pudottamalla',
    'Only hidden': 'Näytä vain piilotetut',
    Hide: 'Piilota',
    Restore: 'Palauta',

    Languages: 'Kielet',
    Name: 'Nimi',
    Description: 'Kuvaus',
    'You can upload one (mp4) video file by dropping it here':
      'Voit ladata yhden videotiedoston (mp4) raahaamalla ja pudottamalla sen tähän',
    'Upload one video file': 'Lataa yksi videotiedosto',
    'Upload one image file': 'Lataa yksi kuvatiedosto',
    'You can upload by dragging and dropping one image (jpg, jpeg, png) file)':
      'Voit ladata yhden kuvatiedoston (jpg, jpgeg, png) raahaamalla ja pudottamalla sen tähän ',
    'You can upload an image (png) file':
      'Void ladata yhden kuvatiedoston (png)',
    'Upload image': 'Lataa kuva',
    'Upload a video file': 'Lataa videotiedosto',
    'You can upload 1 video (mp4) file':
      'Voit ladata yhden videotiedoston (mp4)',
    'Upload files': 'Lataa tiedostoja',
    'You can upload multiple files by dropping them here':
      'Voit ladata useita tiedostoja pudottamalla ne tähän',
    Winter: 'Talvi',
    Spring: 'Kevät',
    Summer: 'Kesä',
    Autumn: 'Syksy',
    'Top left corner': 'Vasen yläkulma',
    'Top right corner': 'Oikea yläkulma',
    'Bottom left corner': 'Vasen alakulma',
    'Bottom right corner': 'Oikea alakulma',
    'Upload file': 'Lataa tiedosto',
    'You can upload an image (jpg, jpeg, png) file by dropping it here':
      'Voit ladta jpg, jpeg, png-päätteisen tiedoston pudottamalla sen tähän',
    'You can upload 2 images (jpg, jpeg, png) by dropping it here':
      'Voit ladata kaksi kuvatiedostoa (jpg, jpeg, png) pudottamalla sen tähän',
    'You can upload 2 audio (mp3) files':
      'Voit ladata kaksi mp3-äänitiedosoa pudottamalla sen tähän',
    'Choose audio (mp3) file': 'Valitse äänitiedosto (mp3)',
    'Choose one image (jpg, jpeg, png)':
      'Valitse yksi kuvatiedosto (jpg, jpeg, png)',
    'You can upload one image (jpg, jpeg, png) file by dropping it here':
      'Voit ladata yhden kuvatiedoston (jpg, jpeg, png) pudottamalla sen tähän',
    'How did you find this route': 'Mitä pidit reitistä'
  }
};
